/**
 * Bracelets collection chip filters (scent type / strength / pet safety).
 * Marks product cards with data-hs-match, then asks hs-bestsellers-pager to re-slice.
 */
(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function getFiltersFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return {
      type: params.get('hs_type') || '',
      level: params.get('hs_level') || '',
      pet: params.get('hs_pet') || '',
    };
  }

  function writeFiltersToUrl(filters) {
    var url = new URL(window.location.href);
    [
      ['hs_type', filters.type],
      ['hs_level', filters.level],
      ['hs_pet', filters.pet],
    ].forEach(function (pair) {
      if (pair[1]) url.searchParams.set(pair[0], pair[1]);
      else url.searchParams.delete(pair[0]);
    });
    url.searchParams.delete('hs_page');
    url.searchParams.delete('page');
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', url.toString());
    }
  }

  function normalizePet(raw) {
    var v = String(raw || '').toLowerCase();
    if (!v || v === 'not specified') return '';
    if (v.indexOf('100% pet-safe') !== -1) return '100% Pet-Safe';
    if (v.indexOf('pet-friendly') !== -1) return 'Pet-Friendly';
    if (
      v.indexOf('pet-free') !== -1 ||
      v.indexOf('not pet-safe') !== -1 ||
      v.indexOf('keep away') !== -1
    ) {
      return 'Pet-Free Zone';
    }
    return String(raw || '').trim();
  }

  function syncChipState(root, filters) {
    ['type', 'level', 'pet'].forEach(function (key) {
      qsa('[data-hs-bfilt="' + key + '"]', root).forEach(function (btn) {
        var val = btn.getAttribute('data-value') || '';
        btn.classList.toggle('is-active', val === (filters[key] || ''));
      });
    });
    var clearBtn = qs('[data-hs-bfilt-clear]', root);
    if (clearBtn) {
      var active = !!(filters.type || filters.level || filters.pet);
      clearBtn.hidden = !active;
    }
  }

  function hideEmptyChips(root, grid) {
    var items = qsa(':scope > .grid__item', grid);
    var present = { type: {}, level: {}, pet: {} };
    items.forEach(function (el) {
      var t = el.getAttribute('data-hs-scent-type') || '';
      var l = el.getAttribute('data-hs-scent-level') || '';
      var p = normalizePet(el.getAttribute('data-hs-pet') || '');
      if (t) present.type[t] = true;
      if (l) present.level[l] = true;
      if (p) present.pet[p] = true;
    });
    qsa('[data-hs-bfilt]', root).forEach(function (btn) {
      var key = btn.getAttribute('data-hs-bfilt');
      var val = btn.getAttribute('data-value') || '';
      if (!val) {
        btn.hidden = false;
        return;
      }
      btn.hidden = !present[key] || !present[key][val];
    });
  }

  function applyFilters(root, grid, filters) {
    var items = qsa(':scope > .grid__item', grid);
    var matchCount = 0;
    items.forEach(function (el) {
      var t = el.getAttribute('data-hs-scent-type') || '';
      var l = el.getAttribute('data-hs-scent-level') || '';
      var p = normalizePet(el.getAttribute('data-hs-pet') || '');
      var ok = true;
      if (filters.type && t !== filters.type) ok = false;
      if (filters.level && l !== String(filters.level)) ok = false;
      if (filters.pet && p !== filters.pet) ok = false;
      el.setAttribute('data-hs-match', ok ? '1' : '0');
      if (ok) matchCount += 1;
    });

    var countEl = qs('[data-hs-bfilt-count]', root);
    if (countEl) {
      if (filters.type || filters.level || filters.pet) {
        countEl.textContent =
          matchCount === 1 ? '1 bracelet matches' : matchCount + ' bracelets match';
      } else {
        countEl.textContent = '';
      }
    }

    var pager = grid.closest('hs-bestsellers-pager');
    if (pager && typeof pager.apply === 'function') {
      pager.apply();
    } else {
      items.forEach(function (el) {
        el.hidden = el.getAttribute('data-hs-match') === '0';
      });
    }
  }

  function bindGuideChips() {
    qsa('[data-hs-bfilt-jump]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-hs-bfilt-jump');
        var val = btn.getAttribute('data-value') || '';
        var root = qs('[data-hs-bracelet-filters]');
        var grid = qs('[data-hs-bs-grid]') || qs('#product-grid');
        if (!root || !grid || !key) return;
        var filters = getFiltersFromUrl();
        filters[key] = val;
        writeFiltersToUrl(filters);
        syncChipState(root, filters);
        applyFilters(root, grid, filters);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    var root = qs('[data-hs-bracelet-filters]');
    var grid = qs('[data-hs-bs-grid]') || qs('#product-grid');
    if (!root || !grid) return;

    // Ensure pet attrs are normalized on cards for matching.
    qsa(':scope > .grid__item', grid).forEach(function (el) {
      var p = normalizePet(el.getAttribute('data-hs-pet') || '');
      if (p) el.setAttribute('data-hs-pet', p);
    });

    hideEmptyChips(root, grid);
    var filters = getFiltersFromUrl();
    syncChipState(root, filters);
    applyFilters(root, grid, filters);

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-hs-bfilt]');
      var clear = e.target.closest('[data-hs-bfilt-clear]');
      if (clear) {
        filters = { type: '', level: '', pet: '' };
        writeFiltersToUrl(filters);
        syncChipState(root, filters);
        applyFilters(root, grid, filters);
        return;
      }
      if (!chip || !root.contains(chip)) return;
      var key = chip.getAttribute('data-hs-bfilt');
      var val = chip.getAttribute('data-value') || '';
      filters[key] = val;
      writeFiltersToUrl(filters);
      syncChipState(root, filters);
      applyFilters(root, grid, filters);
    });

    bindGuideChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
